import { render, staticRenderFns } from "./communicationRecord.vue?vue&type=template&id=d79f24ec&scoped=true"
import script from "./communicationRecord.vue?vue&type=script&lang=js"
export * from "./communicationRecord.vue?vue&type=script&lang=js"
import style0 from "./communicationRecord.vue?vue&type=style&index=0&id=d79f24ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79f24ec",
  null
  
)

export default component.exports